import { useLocation, useNavigate } from "react-router-dom";
import Text from "../styleguide/Text";
import Colors from "../theme/Colors";
import { getFirstLetterUpperCase } from "../utils/parsers";
import { initialMainRoute, inventoryRoutes } from "./routesConstants";

function BreadcrumbsComponent() {
  const location = useLocation();
  const navigate = useNavigate();

  const currentPathArray = location.pathname.split("/").slice(1);
  const isPickingBoxes =
    currentPathArray[0] === inventoryRoutes.inventory &&
    currentPathArray[1] === inventoryRoutes.pickingBoxStocks;

  const filteredDisplayPath = currentPathArray
    .map((segment, index) => ({ segment, index }))
    .filter(
      ({ segment, index }) =>
        isNaN(Number(segment)) &&
        !(
          isPickingBoxes &&
          (index === 0 || (index === 2 && currentPathArray.length > 3))
        ),
    );

  if (!currentPathArray.includes(initialMainRoute)) {
    filteredDisplayPath.unshift({ segment: initialMainRoute, index: -1 });
  }

  if (filteredDisplayPath.length === 0) return null;

  return (
    <div
      className="bg-white py-5 px-7"
      style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
      {filteredDisplayPath.map(({ segment, index }, idx) => {
        const isDashboard = segment === initialMainRoute;
        const isLast = idx === filteredDisplayPath.length - 1;
        const steps = filteredDisplayPath.length - 1 - idx;

        return (
          <span key={segment} style={{ display: "flex", alignItems: "center" }}>
            {isLast ? (
              <Text color={Colors.black}>
                {getFirstLetterUpperCase(segment)}
              </Text>
            ) : (
              <span
                className="text-muted"
                style={{ cursor: "pointer" }}
                onClick={
                  isDashboard
                    ? () => navigate("/")
                    : isPickingBoxes
                    ? () =>
                        navigate(
                          `/${currentPathArray.slice(0, index + 1).join("/")}`,
                        )
                    : () => navigate(-steps)
                }>
                {getFirstLetterUpperCase(segment)}
              </span>
            )}
            {!isLast && (
              <span className="text-muted" style={{ margin: "0 8px" }}>
                /
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
}

export default BreadcrumbsComponent;
